import React, {Component} from "react";
import '../EMR.css';
import InsuranceReferralStatus from "../../../insurance/enums/InsuranceReferralStatus";
import DateUtil from "../../../../utils/DateUtil";
import {Button} from "react-bootstrap";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import {Dropdown as PrimeDropdown} from "primereact/components/dropdown/Dropdown";
import EligibilityStatusEnum from "../../../insurance/enums/EligibilityStatusEnum";
import {Modal} from "../../../../components";
import HoverableDescriptionBox from "../../../../components/hoverable-desc-box/HoverableDescriptionBox";
import DirectBillingReferralTypeEnum from "../../../insurance/enums/DirectBillingReferralTypeEnum";

export default class InsuranceStatus extends Component {

    constructor(props) {
        super(props);
        this.state = {};
    }

    createNewDirectBillingItem = () => {
        const directBilling = this.props.insuranceApproval.directBilling;
        const params = {
            type: this.state.newDB.type,
            sessionsPerCpt: this.state.newDB.sessionsPerCpt,
            visitId: this.props.currentVisit.id
        };

        RemotingService.postRemoteCall(
            `api/insurance/coordinator/v2/direct-billing/${directBilling.id}/copy`,
            params,
            () => {
                directBilling.status = 'COMPLETED';
                this.setState({newDirectBillingModalVisible: false});
            }
        );
    }

    getSessionRangeForItem(item, type) {
        if (type === 'ADDITIONAL_SESSIONS') {
            return Array.from({ length: 20 }, (_, i) => ({ label: String(i + 1), value: i + 1 }));
        }
        const remaining = Math.max(0, (item.noOfApprovedSessions || 0) - (item.noOfUsedSessions || 0));
        return Array.from({ length: remaining + 1 }, (_, i) => ({ label: String(i), value: i }));
    }

    renderSessionsTable() {
        const directBilling = this.props.insuranceApproval?.directBilling;
        const items = directBilling?.items;
        if (!items || items.length === 0) return null;

        return (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: '12px' }}>
                <tbody>
                    {items.map((item, index) => (
                        <tr key={index} style={{ borderBottom: index < items.length - 1 ? '1px solid #eee' : 'none' }}>
                            <td style={{ padding: '2px 6px', fontWeight: 600 }}>{item.cpt?.cptCode || '-'}</td>
                            <td style={{ padding: '2px 6px', textAlign: 'center' }}>
                                {item.noOfUsedSessions}/{item.noOfApprovedSessions}
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        );
    }

    renderDiagnosisGroups() {
        const {insuranceApproval} = this.props;
        const directBilling = insuranceApproval?.directBilling;

        if (!directBilling || !directBilling.diagnosisGroup || !directBilling.diagnosisGroup.diagnosisItems || directBilling.diagnosisGroup.diagnosisItems.length === 0) {
            return null;
        }

        const sortedItems = [...directBilling.diagnosisGroup.diagnosisItems].sort((a, b) => {
            if (a.level === "PRINCIPAL" && b.level !== "PRINCIPAL") return -1;
            if (a.level !== "PRINCIPAL" && b.level === "PRINCIPAL") return 1;
            return 0;
        });

        return (
            <div className="diagnosis-group-container">
                {sortedItems.map((item, index) => {
                    const prefix = item.level === "PRINCIPAL" ? "P: " : "S: ";
                    const header = `${prefix}${item.code}`;

                    return (
                        <HoverableDescriptionBox
                            key={index}
                            header={header}
                            description={item.description}
                        />
                    );
                })}
            </div>
        );
    }

    render() {
        const {insuranceApproval} = this.props;
        let directBillingV2 = insuranceApproval?.directBilling;

        return (
            <div>
                <div className={"pl-3 row no-margin"}>
                    <div className={"col-3 flex-column no-padding"}>
                        <div className={"col-6 no-padding dim14-form-label"}>
                            Visit Date:
                        </div>
                        <div className={"col-6 no-padding"}>
                            {DateUtil.formatDate(this.props.currentVisit.appointment.startTime)}
                        </div>
                    </div>
                    <div className={"col-5 flex-column no-padding"}>
                        <div className={"col-6 no-padding dim14-form-label"}>
                            Referring Physician:
                        </div>
                        <div className={"col-6 no-padding"}>
                            {directBillingV2?.referrerName || ''}
                        </div>
                    </div>
                </div>
                <br/>

                <div className={"content-card"}>
                    <div className={"complaints-wrapper"}>
                        <div className={"display-flex"}>
                            <div className={"col-sm-5 no-padding dim14-form-label"}>Insurance Status:</div>
                            <div className={"col-sm-7 no-padding overflow-wrap-anywhere"}>
                                {insuranceApproval && EligibilityStatusEnum[insuranceApproval.eligibilityStatus]?.name}
                            </div>
                        </div>
                        <div className={"display-flex"}>
                            <div className={"col-sm-5 no-padding dim14-form-label"}>Reference No:</div>
                            <div className={"col-sm-7 no-padding overflow-wrap-anywhere"}>
                                {directBillingV2?.referenceNo || ''}
                            </div>
                        </div>
                        <div className={"display-flex"}>
                            <div className={"col-sm-5 no-padding dim14-form-label"}>Diagnosis:</div>
                            <div className={"col-sm-7 no-padding overflow-wrap-anywhere"}>
                                {this.renderDiagnosisGroups()}
                            </div>
                        </div>
                        <div className={"display-flex"}>
                            <div className={"col-sm-5 no-padding dim14-form-label"}>Claim Status:</div>
                            <div className={"col-sm-7 no-padding overflow-wrap-anywhere"}>
                                {directBillingV2 && DirectBillingReferralTypeEnum[directBillingV2.referralType] === DirectBillingReferralTypeEnum.INTERNAL && 'Direct Billing: '}
                                {directBillingV2 && DirectBillingReferralTypeEnum[directBillingV2.referralType] === DirectBillingReferralTypeEnum.EXTERNAL && 'External Referral: '}
                                {directBillingV2 && directBillingV2.status ? InsuranceReferralStatus[directBillingV2.status].name : ''}
                            </div>
                        </div>
                        <div className={"display-flex"}>
                            <div className={"col-sm-5 no-padding dim14-form-label"}>Sessions:</div>
                            <div className={"col-sm-7 no-padding overflow-wrap-anywhere"}>
                                {this.renderSessionsTable()}
                            </div>
                        </div>
                        <div className={"display-flex"}>
                            <div className={"col-sm-5 no-padding dim14-form-label"}>Validity:</div>
                            <div className={"col-sm-7 no-padding overflow-wrap-anywhere"}>
                                {directBillingV2 && directBillingV2.validUntil ?
                                    DateUtil.formatDate(directBillingV2.validUntil, 'Do MMM YYYY') : ''}
                            </div>
                        </div>
                        {directBillingV2 && !directBillingV2.copiedToId
                            && (directBillingV2.items || []).length > 0
                            && directBillingV2.items.some(i => i.noOfUsedSessions === i.noOfApprovedSessions) &&
                        <Button variant={"light"} size={"sm"}
                                onClick={() => {
                                    const items = directBillingV2?.items || [];
                                    const sessionsPerCpt = {};
                                    items.forEach(item => {
                                        const cptCode = item.cpt?.cptCode;
                                        if (cptCode) sessionsPerCpt[cptCode] = 1;
                                    });
                                    this.setState({
                                        newDirectBillingModalVisible: true,
                                        newDB: {
                                            text: 'Request More Sessions',
                                            type: 'ADDITIONAL_SESSIONS',
                                            sessionsPerCpt
                                        }
                                    });
                                }}>
                            Request More Sessions
                        </Button>}
                        {directBillingV2 && !directBillingV2.copiedToId
                            && directBillingV2.validUntil
                            && DateUtil.getDifferenceInDays(directBillingV2.validUntil, new Date()) < 7 &&
                        <Button variant={"light"} size={"sm"}
                                onClick={() => {
                                    const items = directBillingV2?.items || [];
                                    const sessionsPerCpt = {};
                                    items.forEach(item => {
                                        const cptCode = item.cpt?.cptCode;
                                        if (cptCode) {
                                            const remaining = Math.max(0, (item.noOfApprovedSessions || 0) - (item.noOfUsedSessions || 0));
                                            sessionsPerCpt[cptCode] = remaining;
                                        }
                                    });
                                    this.setState({
                                        newDirectBillingModalVisible: true,
                                        newDB: {
                                            text: 'Extend Validity',
                                            type: 'VALIDITY_EXTENSION',
                                            sessionsPerCpt
                                        }
                                    });
                                }}>
                            Extend Validity
                        </Button>}
                    </div>
                </div>
                {this.state.newDirectBillingModalVisible &&
                <Modal visible={this.state.newDirectBillingModalVisible}
                       header={this.state.newDB.text}
                       submitContent="Confirm"
                       submitAction={this.createNewDirectBillingItem}
                       closeAction={() => this.setState({newDirectBillingModalVisible: false})}
                       contentStyle={{width: '380px'}}>
                    <table className="table table-sm table-bordered">
                        <thead>
                            <tr>
                                <th style={{ fontSize: '13px' }}>CPT Code</th>
                                <th style={{ fontSize: '13px' }}>Used / Approved</th>
                                <th style={{ fontSize: '13px' }}>Sessions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {(directBillingV2?.items || []).map(item => {
                                const cptCode = item.cpt?.cptCode;
                                const range = this.getSessionRangeForItem(item, this.state.newDB.type);
                                return (
                                    <tr key={cptCode}>
                                        <td style={{ fontSize: '13px', verticalAlign: 'middle' }}>{cptCode}</td>
                                        <td style={{ fontSize: '13px', verticalAlign: 'middle' }}>
                                            {item.noOfUsedSessions || 0} / {item.noOfApprovedSessions || 0}
                                        </td>
                                        <td style={{ verticalAlign: 'middle' }}>
                                            <PrimeDropdown
                                                options={range}
                                                optionLabel="label"
                                                optionValue="value"
                                                value={this.state.newDB.sessionsPerCpt?.[cptCode] ?? range[0].value}
                                                onChange={(e) => {
                                                    const sessionsPerCpt = { ...this.state.newDB.sessionsPerCpt, [cptCode]: e.value };
                                                    this.setState(prev => ({ newDB: { ...prev.newDB, sessionsPerCpt } }));
                                                }}
                                                style={{ width: '100px' }}
                                            />
                                        </td>
                                    </tr>
                                );
                            })}
                        </tbody>
                    </table>
                </Modal>}
            </div>
        );
    }
}
